import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Day2, Debattle, Vaad, PurvaPaschima, Creative, MathArch, Navigating, CodeCrafts, Caveat, Eximii, Geonomy, Laxmagna, Explicadum, ThroneOfApollo, ThemeWalk } from 'views/Goonj2024/components';

const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    
      <Box id='Day2'>
        
        <br></br>
        <br></br>
        <Typography variant='h6' align='center' fontWeight={700} >
        DAY 2
        </Typography>

        <Box marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>

          <Day2/>
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}  align='left'>DEBATTLE</Typography>
              <Typography  align='right'>- Colliding thoughts, Symphonic blends</Typography>

            </Box>
            <AccordionDetails>
            Offered a platform for spirited debates, where participants showcased their clarity of thought and eloquence.
            </AccordionDetails>

            <Debattle/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
            {/* <a href="#Day2" align='right'>Back to DAY 2</a> */}
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}  align='left'>Vaad-Vivaad</Typography>
              <Typography  align='right'> - Hindi Verbal Showdown</Typography>

            </Box>
            <AccordionDetails>
            A Hindi debating competition where participants demonstrated their argumentative abilities and eloquence in a lively contest.
            </AccordionDetails>

            <Vaad/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Purva Paschima</Typography>
              <Typography align='right'> - Dance Fusion Fiesta: East Meets West</Typography>

            </Box>
            <AccordionDetails>
            This unique platform invited participants to blend Indian Classical and Western dance elements, creating a harmonious and captivating fusion of cultural expression.

            </AccordionDetails>

            <PurvaPaschima/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Creative Advertisement</Typography>
              <Typography align='right'> - Ad-Venture: Creativity Unleashed!</Typography>

            </Box>
            <AccordionDetails>
            This competition challenged participants to craft humorous advertisements for fictional products, allowing them to exhibit their creativity and artistic flair.
            </AccordionDetails>

            <Creative/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Math Arch </Typography>
              <Typography align='right'>- Architectural Math Marvels</Typography>

            </Box>
            <AccordionDetails>
            Participants constructed models of architectural marvels from selected dynasties, explaining the mathematical concepts inherent in the designs.
            </AccordionDetails>

            <MathArch/>
            {/* <Synergy1/> */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Navigating the Storm </Typography>
              <Typography align='right'>- Crisis Command: Science Solutions</Typography>

            </Box>
            <AccordionDetails>
            This event explored scientific adversities and crises, focusing on strategies to address them.
            </AccordionDetails>

            <Navigating/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Code Crafters</Typography>
              <Typography align='right'>- AI Innovators: Code Crafters</Typography>

            </Box>
            <AccordionDetails>
            Students exhibited their programming skills in Python, debugging, coding, and presenting AI video projects.
            </AccordionDetails>

            <CodeCrafts/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>
          <br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}  align='left'>Caveat Emptor</Typography>
    <Typography  align='right'> - Sustainable Real Estate Showcase</Typography>

  </Box>
  <AccordionDetails>
  Participants designed innovative and sustainable real estate projects focusing on profitability and efficiency.
  </AccordionDetails>

  <Caveat/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Eximii Magistri</Typography>
    <Typography align='right'> - Managerial Masterclass</Typography>

  </Box>
  <AccordionDetails>
  Students demonstrated their managerial skills to prove their capabilities as top managers.

  </AccordionDetails>

  <Eximii/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Geonomy</Typography>
    <Typography align='right'> - Topography Trade-Off</Typography>

  </Box>
  <AccordionDetails>
  Geonomy Participants created 3D models of countries' topographies and explained their impact on trade, economy, and policies.
  </AccordionDetails>

  <Geonomy/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Lex Magna </Typography>
    <Typography align='right'>- Cryptic Courtroom Conundrums</Typography>

  </Box>
  <AccordionDetails>
  Participants solved cryptic courtroom cases, unraveling mysteries through analysis and strategic arguments.
  </AccordionDetails>

  <Laxmagna/>
  {/* <Synergy1/> */}
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Explicadum </Typography>
    <Typography align='right'>- Crisis Chronicles: Fact-Based Reports</Typography>

  </Box>
  <AccordionDetails>
  Participants wrote fact-based reports on crisis and made compelling presentations.
  </AccordionDetails>

  <Explicadum/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>The Throne of Apollo</Typography>
    <Typography align='right'>- Battle of the Bands</Typography>

  </Box>
  <AccordionDetails>
  An inter-school rock band competition where bands competed to claim the throne through their performance.
  </AccordionDetails>

  <ThroneOfApollo/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Concept Catwalk</Typography>
    <Typography align='right'>- Thematic Interpretations</Typography>

  </Box>
  <AccordionDetails>
  Participants presented theme-based interpretations of concepts with different subject domains through fashion.
  </AccordionDetails>

  <ThemeWalk/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
        </Box>
      </Box>
  
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Day2Goonj2024 = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Day2Goonj2024;